export class Physician{
    name: string
    phoneNumber: string

    constructor(){
        this.name = null;
        this.phoneNumber = null;
    }
}